import React, { Component, ReactNode } from 'react';

import cx from 'classnames';

import { Button } from 'antd';
import { CognitoAction, signInWithAzure, signInWithGoogle } from '../../../services/cognito';

import styles from './socialLoginButtons.module.scss';
import { isProductionEnv } from '../../../utils/platform';

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, string>[];
};

declare const window: WindowWithDataLayer;

interface ISocialLoginButtonsProps {
  action: CognitoAction;
}

class SocialLoginButtons extends Component<ISocialLoginButtonsProps> {
  constructor(props: ISocialLoginButtonsProps) {
    super(props);

    this.signInWithGoogle = this.signInWithGoogle.bind(this);
    this.signInWithAzure = this.signInWithAzure.bind(this);
  }

  private signInWithGoogle() {
    const { action } = this.props;
    if (isProductionEnv() && action !== CognitoAction.Login) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'google_sign_up_click' });
    }
    signInWithGoogle(action);
  }

  private signInWithAzure() {
    const { action } = this.props;
    if (isProductionEnv() && action !== CognitoAction.Login) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'microsoft_sign_up_click' });
    }
    signInWithAzure(action);
  }

  render(): ReactNode {
    const { action } = this.props;
    const actionMessage = action === CognitoAction.Login ? 'Log in' : 'Sign up';

    return (
      <div className={cx(styles.mainWrapper)}>
        <div>
          <Button
            className={cx(styles.button, styles.googleSignIn)}
            type="text"
            onClick={this.signInWithGoogle}
          >
            <div className={styles.logo} />
            {actionMessage} with Google
          </Button>
        </div>
        <div>
          <Button
            className={cx(styles.button, styles.azureSignIn)}
            type="text"
            onClick={this.signInWithAzure}
          >
            <div className={styles.logo}></div>
            {actionMessage} with Microsoft
          </Button>
        </div>
      </div>
    );
  }
}

export { SocialLoginButtons };
